<template>
	<v-carousel :height="300" width="100%">
		<v-carousel-item v-for="(substep, i) in substeps" :key="i">
			<step :step="substep" />
		</v-carousel-item>
	</v-carousel>
</template>

<script>
import Step from "./Step";

export default {
	components: {
		Step,
	},
	props: {
		substeps: Array,
	},
	computed: {
		height() {
			return this.$vuetify.breakpoint.xsOnly ? 150 : 300;
		},
	},
};
</script>

<style></style>
